import axios from './axiosInstance';

export type AdminPushRecipientType = 'user' | 'user_group';

interface PostAdminPushNotificationParams {
  parkId: string;
  title: string;
  body: string;
  recipientType: AdminPushRecipientType;
  recipientId: string;
}

interface PostAdminPushNotificationResponse {
  recipientCount: number;
  recipientUserIds: string[];
  adminMessageId: string;
  resolvedEntityType: string;
  resolvedEntityId: string;
}

const postAdminPushNotification = ({
  parkId,
  title,
  body,
  recipientType,
  recipientId,
}: PostAdminPushNotificationParams): Promise<PostAdminPushNotificationResponse> => {
  return axios
    .post(`/admin/areas/${parkId}/notifications/push`, {
      title,
      body,
      recipientType,
      recipientId,
    })
    .then((response) => response.data);
};

const adminPushNotificationFunctions = {
  postAdminPushNotification,
};

export default adminPushNotificationFunctions;
